import {manage} from "@/api/Client";

class IotApi {
    async broadcastMessage(type, payload, options) {
        const { data: { data } } = await manage.post(`iot/publish/${type}`, payload, options)
        return data
    }
}

export default new IotApi()